// From 992px (below it the sidebar is a drawer) up to 1280px an open 265px sidebar leaves the invoice
// list too little room for its table, so the sidebar closes to its 75px icon rail there by itself —
// a 1024×768 screen keeps the table. The user's own toggle wins until the window moves into another
// range; a sidebar the panel closed opens again when the window leaves the range.
// Only with a mouse (2026-10-17): a touch tablet has no hover to read the rail's labels, so its sidebar stays open.
export const SIDEBAR_AUTO_MINIMIZE_QUERY = '(min-width: 992px) and (max-width: 1279.98px) and (hover: hover)'

const MINIMIZE_ATTRIBUTE = 'data-kt-app-sidebar-minimize'
// On the body, so a remounted layout (after a RegisterLayout page) still knows who closed it.
const CLOSED_BY_PANEL_ATTRIBUTE = 'data-mp-sidebar-auto-minimized'

const isMinimized = () => document.body.getAttribute(MINIMIZE_ATTRIBUTE) === 'on'

const setMinimized = (toggle: HTMLElement | null, minimized: boolean) => {
  if (minimized) {
    document.body.setAttribute(MINIMIZE_ATTRIBUTE, 'on')
  } else {
    document.body.removeAttribute(MINIMIZE_ATTRIBUTE)
  }
  // The toggle (Metronic ToggleComponent) reads its state from the body attribute; its arrow
  // follows the 'active' class.
  toggle?.classList.toggle('active', minimized)
}

export const watchSidebarAutoMinimize = (toggle: HTMLElement | null): (() => void) => {
  if (typeof window.matchMedia !== 'function') {
    return () => undefined
  }

  const query = window.matchMedia(SIDEBAR_AUTO_MINIMIZE_QUERY)

  const apply = () => {
    if (query.matches) {
      if (!isMinimized()) {
        setMinimized(toggle, true)
        document.body.setAttribute(CLOSED_BY_PANEL_ATTRIBUTE, 'true')
      }
    } else if (document.body.hasAttribute(CLOSED_BY_PANEL_ATTRIBUTE)) {
      // Wider than 1280px, or a drawer below 992px, which shows its brand name and footer only
      // without the attribute.
      setMinimized(toggle, false)
      document.body.removeAttribute(CLOSED_BY_PANEL_ATTRIBUTE)
    }
  }

  const userToggled = () => {
    document.body.removeAttribute(CLOSED_BY_PANEL_ATTRIBUTE)
  }

  // A remounted layout renders the toggle without 'active' even when the sidebar is closed.
  toggle?.classList.toggle('active', isMinimized())
  apply()

  // Safari before 14 has only addListener.
  if (typeof query.addEventListener === 'function') {
    query.addEventListener('change', apply)
  } else {
    query.addListener(apply)
  }
  toggle?.addEventListener('click', userToggled)

  return () => {
    if (typeof query.removeEventListener === 'function') {
      query.removeEventListener('change', apply)
    } else {
      query.removeListener(apply)
    }
    toggle?.removeEventListener('click', userToggled)
  }
}
